<div style="background-color: #fff; margin-left: 25px; margin-top: 80px;">
  <h2>{{'signOut' | translate}}</h2>
  <form>
    <button (click)="signOut()" class="btn btn-primary" type="submit">{{'signOut'|translate}} </button>
  </form>
</div>